<template>
  <div class="fliggy-offline-applicant-form">
    <div class="row-item">
      <div
        class="form-item"
        :class="{'is-error': isShowError(applicantItem, 'surname')}"
      >
        <div class="item-label">姓(中文)</div>
        <div class="item-content">
          <el-input
            :value="applicantItem.surname"
            @input="($event) => changeApplicantItemFieldFnForTransform($event, 'surname', applicantItem)"
            placeholder="输入中文姓"
            @blur="changeApplicantItemFieldFn(true, 'show_error_surname', applicantItem)"
          ></el-input>
        </div>
      </div>
      <div
        class="form-item"
        :class="{'is-error': isShowError(applicantItem, 'given_name')}"
      >
        <div class="item-label">名(中文)</div>
        <div class="item-content">
          <el-input
            :value="applicantItem.given_name"
            @input="($event) => changeApplicantItemFieldFnForTransform($event, 'given_name', applicantItem)"
            placeholder="输入中文名"
            @blur="changeApplicantItemFieldFn(true, 'show_error_given_name', applicantItem)"
          ></el-input>
        </div>
      </div>
    </div>
    <div class="row-item">
      <div
        class="form-item"
        :class="{'is-error': isShowError(applicantItem, 'surname_pinyin')}"
      >
        <div class="item-label">姓(拼音)</div>
        <div class="item-content">
          <el-input
            :value="applicantItem.surname_pinyin"
            class="upper"
            @input="($event) => changeApplicantItemFieldFnForUpper($event, 'surname_pinyin', applicantItem)"
            placeholder="输入英文大写字母"
            @blur="changeApplicantItemFieldFn(true, 'show_error_surname_pinyin', applicantItem)"
          ></el-input>
        </div>
      </div>
      <div
        class="form-item"
        :class="{'is-error': isShowError(applicantItem, 'given_name_pinyin')}"
      >
        <div class="item-label">名(拼音)</div>
        <div class="item-content">
          <el-input
            :value="applicantItem.given_name_pinyin"
            class="upper"
            @input="($event) => changeApplicantItemFieldFnForUpper($event, 'given_name_pinyin', applicantItem)"
            placeholder="输入英文大写字母"
            @blur="changeApplicantItemFieldFn(true, 'show_error_given_name_pinyin', applicantItem)"
          ></el-input>
        </div>
      </div>
    </div>
    <div class="row-item">
      <div
        class="form-item"
        :class="{'is-error': isShowError(applicantItem, 'credential_no')}"
      >
        <div class="item-label">护照号</div>
        <div class="item-content">
          <el-input
            :value="applicantItem.credential_no"
            class="upper"
            @input="($event) => changeApplicantItemFieldFnForUpper($event, 'credential_no', applicantItem)"
            placeholder="输入护照号"
            :maxlength="9"
            @blur="changeApplicantItemFieldFn(true, 'show_error_credential_no', applicantItem)"
          ></el-input>
        </div>
      </div>
      <div
        class="form-item identity"
        :class="{'is-error': isShowError(applicantItem, 'identity_id')}"
        v-if="!isUniversalIdentity"
      >
        <div class="item-label">旅客身份</div>
        <div class="item-content">
          <el-select
            :value="applicantItem.identity_id"
            @input="($event) => changeApplicantItemFieldFn($event, 'identity_id', applicantItem)"
            placeholder="选择身份"
            popper-class="go-select"
          >
            <el-option
              :label="identitys[identity]"
              :value="identity"
              v-for="(identity, idx) in identityList"
              :key="'identity_' + idx"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'pinyin4js';
import statusMap from '@/libs/status';
import { fliggyOfflineFormCheck } from './fliggy-offline-form-check';

export default {
  components: {},
  props: {
    isUniversalIdentity: Boolean,
    identityList: Array,
    applicantItem: Object,
    changeApplicantItemFieldFn: Function,
    submited: Boolean,
  },
  data() {
    return {
      identitys: statusMap.identity, // 所有身份
      // created-order-dialog也有校验，请同步修改
      rules: fliggyOfflineFormCheck,
    };
  },
  computed: {},
  created() {},
  methods: {
    // 是否需要显示错误
    isShowError(item, field) {
      const hasShow = this.submited || item[`show_error_${field}`];
      const rule = this.rules[field];
      return hasShow && rule && rule(item[field]); 
    },

    // 修改字段，主要为了中文转拼音
    changeApplicantItemFieldFnForTransform(value, field, item) {
      this.changeApplicantItemFieldFn(value, field, item);

      const pinyinMap = {
        surname: 'surname_pinyin',
        given_name: 'given_name_pinyin',
      };

      // 如果是填写姓名，自动填写拼音
      if (pinyinMap[field]) {
        const transformValue = PinyinHelper.convertToPinyinString(
          value,
          '',
          PinyinFormat.WITHOUT_TONE,
        );
        this.changeApplicantItemFieldFn(
          transformValue ? transformValue.toUpperCase() : transformValue,
          pinyinMap[field],
          item,
        );
      }

    },

    // 主要为了转大写
    changeApplicantItemFieldFnForUpper(value, field, item) {
      this.changeApplicantItemFieldFn(typeof value === 'string' ? value.toUpperCase() : value, field, item);
    },

  },
};
</script>

<style lang="less" scoped>
.fliggy-offline-applicant-form{
  flex-grow: 1;
  overflow: hidden;
  border: 1px solid #DEE2E6;
  background: #fff;
  border-radius: 2px;
  .row-item{
    display: flex;
    position: relative;
    &::before{
      content: "";
      position: absolute;
      left: 10px;
      right: 10px;
      bottom: 0;
      height: 1px;
      background: #E9EEF2;
      z-index: 5;
    }
    
    &:last-child{
      &::before{
        display: none;
      }
    }
    .form-item{
      flex: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
      position: relative;
      min-height: 40px;
      &::before{
        content: "";
        position: absolute;
        top: 8px;
        bottom: 8px;
        left: 0;
        width: 1px;
        background: #E9EEF2;
      }
      &:first-child{
        &::before{
          display: none;
        }
      }
      &.is-error{
        .item-label{
          color: #ff5a60;
        }
      }

      .item-label{
        padding-left: 16px;
        overflow: hidden;
        display: flex;
        align-items: center;
        width: 92px;
        flex-shrink: 0;
        color: #5F666E;
      }
      .item-content{
        flex-grow: 1;
        overflow: hidden;
        height: 100%;
        .upper {
          /deep/ input {
            text-transform: uppercase;
          }
        }
        /deep/ .el-input{
          height: 100%;
          .el-input__inner{
            border: none;
            height: 100%;
            padding: 0;
            padding-right: 15px;
            color: #2F333D;
          }
        }
        /deep/ .el-select{
          height: 100%;
          .el-input__icon{
            color: #91999F;
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/add-order/created-order/components/ota/fliggy-offline-applicant-form.vue